import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTypingAnimation } from '../hooks/useTypingAnimation'
import { AnimatedBackground } from '../components/AnimatedBackground'
import { EdgeBlurSlider } from '../components/EdgeBlurSlider'
import { ThemeToggle } from '../components/ThemeToggle'
import { Footer } from '../components/Footer'

export default function Home() {
  const [blurAmount, setBlurAmount] = useState(0)
  const navigate = useNavigate()
  const lines = [
    "Seto Labs",
    "We Build Intelligent Software, Beautifully and Fast",
    "> Expertise: AI Solutions, B2B SaaS, Mobile, Design, and Scalable Architectures",
    "> Start your journey with us today.",
    "> Ready to get started? Reach Out",
  ]
  
  const { displayedLines, isComplete } = useTypingAnimation(lines, 30)

  const handleNavigation = (href: string) => {
    navigate(href)
  }

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-[#d6dbdc] dark:bg-black">
      <style>{`
        @keyframes gradient-animation-1 {
          0%, 100% { opacity: 1; }
          33%, 66% { opacity: 0; }
        }
        @keyframes gradient-animation-2 {
          0%, 100% { opacity: 0; }
          33% { opacity: 1; }
          66% { opacity: 0; }
        }
        @keyframes gradient-animation-3 {
          0%, 33%, 100% { opacity: 0; }
          66% { opacity: 1; }
        }

        .animate-gradient-1 {
          background: radial-gradient(circle at top right, rgba(59, 130, 246, 0.5) 0%, rgba(167, 139, 250, 0.5) 25%, rgba(244, 114, 182, 0.5) 50%, rgba(244, 114, 182, 0.05) 75%, transparent 100%);
          animation: gradient-animation-1 15s infinite;
        }
        .animate-gradient-2 {
          background: radial-gradient(circle at top right, rgba(167, 139, 250, 0.5) 0%, rgba(244, 114, 182, 0.5) 25%, rgba(59, 130, 246, 0.5) 50%, rgba(59, 130, 246, 0.05) 75%, transparent 100%);
          animation: gradient-animation-2 15s infinite;
        }
        .animate-gradient-3 {
          background: radial-gradient(circle at top right, rgba(244, 114, 182, 0.5) 0%, rgba(59, 130, 246, 0.5) 25%, rgba(167, 139, 250, 0.5) 50%, rgba(167, 139, 250, 0.05) 75%, transparent 100%);
          animation: gradient-animation-3 15s infinite;
        }

        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
        .animate-blink {
          animation: blink 3s infinite;
        }
      `}</style>
      <AnimatedBackground blurAmount={blurAmount} />
      <div className="fixed top-4 right-4 z-20 flex flex-col items-end space-y-4">
        <ThemeToggle />
        <EdgeBlurSlider onChange={setBlurAmount} />
      </div>
      <div className="relative z-10 min-h-screen w-full flex flex-col justify-center items-start p-12">
        <div className="max-w-2xl font-mono">
          {displayedLines.map((line, index) => (
            <div key={index} className={`mb-4 ${
              index === 0 ? 'text-3xl font-bold text-black dark:text-white' : 
              index === 1 ? 'text-xl text-gray-700 dark:text-gray-300 mb-6' : 
              'text-gray-800 dark:text-gray-200'
            }`}>
              {index === displayedLines.length - 1 ? (
                <>
                  {line.split('Reach Out')[0]}
                  {isComplete && (
                    <a 
                      href="mailto:contact@setolabs.com" 
                      className="text-[#ff735a] underline hover:text-[#ff8f7a] transition-colors"
                    >
                      Reach Out
                    </a>
                  )}
                </>
              ) : (
                line
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer onNavigate={handleNavigation} />
    </div>
  )
} 